import { useEffect } from 'react';

import { MetaState } from '../../features/config';
import { updateElementContentById } from '../../helpers/dom/updateElementContentById';

export const useUpdateHiddenSeoElements = (meta?: MetaState | null) => {
  useEffect(() => {
    if (meta) {
      updateElementContentById('seo-title', meta.title);
      updateElementContentById('seo-sub-title', meta.subTitle);
      updateElementContentById('seo-description', meta.description);
      updateElementContentById('seo-keywords', meta.keywords);
    }
  }, [meta]);
};
